module.exports = __webpack_public_path__ + "img/senalando-izqve.png.73ff5cd9.webp";